import { InjectionToken } from "@angular/core";
import { CustomTextGetQueryResult, ECustomTextType } from "../../INTEGRA_Shop_Client";

export abstract class ICustomTextService {
  abstract customTextGet(customTextType: ECustomTextType, group: string, name: string): Promise<CustomTextGetQueryResult>;
}

/** Injection token which makes it possible to provide and inject the interface. */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const ICustomTextServiceToken = new InjectionToken<ICustomTextService>('ICustomTextServiceToken');
